import type { ReactNode } from 'react'

import { DIALOG_ACTIONS_ATTRIBUTE } from '@gto/helpers/dialog-keys'
import { cn } from '@gto/ui/cn'

type FooterProps = {
  children?: ReactNode
  className?: string
}

export const Footer = ({ children, className }: FooterProps) => {
  // The attribute tells `Drawer.Popup` where the call to action of this sheet
  // is, so Enter can press it.
  return (
    <div
      {...{ [DIALOG_ACTIONS_ATTRIBUTE]: '' }}
      className={cn('flex shrink-0 justify-end gap-4 p-4 pt-4', className)}
    >
      {children}
    </div>
  )
}
